import { render, staticRenderFns } from "./domain_list.vue?vue&type=template&id=615b9fe5&scoped=true&"
import script from "./domain_list.vue?vue&type=script&lang=js&"
export * from "./domain_list.vue?vue&type=script&lang=js&"
import style0 from "./domain_list.vue?vue&type=style&index=0&id=615b9fe5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "615b9fe5",
  null
  
)

export default component.exports